import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center space-x-3 pb-4 px-5" }
const _hoisted_2 = { class: "mk-title text-gray-900" }

import { MedKitBadge } from '@bigpicturemedical/medkit';

interface Props {
  title: string;
  pathway: string;
  status: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TouchpointHeader',
  props: {
    title: {},
    pathway: {},
    status: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createVNode(_unref(MedKitBadge), {
      label: _ctx.pathway,
      size: "small",
      class: "mk-label-x-small text-gray-800"
    }, null, 8, ["label"]),
    _createVNode(_unref(MedKitBadge), {
      label: _ctx.status,
      size: "small",
      kind: "low",
      class: "mk-label-x-small text-primary-800"
    }, null, 8, ["label"])
  ]))
}
}

})